import React from 'react'
import clsx from 'clsx'
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { Happyemoji } from 'iconsax-react'
import { ClickAwayListener, IconButton, Popper } from '@mui/material'

import useStyles from './styles'

const EmojiSelect = ({
  handleEmojiSelect,
  disabled,
  additionalClasses = undefined,
  size = 24,
  children
}) => {
  const [open, setOpen] = React.useState(false)
  const ref = React.useRef(null)

  const classes = useStyles()

  const handlePickerSelect = React.useCallback(
    emoji => {
      handleEmojiSelect(emoji)
      setOpen(false)
    },
    [handleEmojiSelect]
  )

  const handleClick = React.useCallback(() => {
    if (!disabled) {
      setOpen(old => !old)
    }
  }, [disabled])

  const handleClose = React.useCallback(() => {
    setOpen(false)
  }, [])

  return (
    <>
      {open && (
        <ClickAwayListener onClickAway={handleClose}>
          <div className={classes.emojiIconClickAwayContainer}>
            <Popper anchorEl={ref.current} open={open} style={{ zIndex: 9999 }}>
              <Picker
                data={data}
                previewPosition={'none'}
                onEmojiSelect={handlePickerSelect}
                autoFocus
              />
            </Popper>
          </div>
        </ClickAwayListener>
      )}

      <div ref={ref}>
        {children ? (
          children({ onClick: handleClick, disabled })
        ) : (
          <IconButton onClick={handleClick} disabled={disabled}>
            <Happyemoji size={size} className={clsx(additionalClasses)} />
          </IconButton>
        )}
      </div>
    </>
  )
}

export default EmojiSelect
